import { useState } from 'react'

const useForceUpdate = () => {
  const [v, set] = useState(true)
  return () => set(!v)
}

export default useForceUpdate
